export default "__VITE_PUBLIC_ASSET__22b261e6__"